module.exports = __webpack_public_path__ + "media/yes7.d8326cbc.mp3";